import { render, staticRenderFns } from "./BargainingContainer.vue?vue&type=template&id=6422d38c&"
import script from "./BargainingContainer.vue?vue&type=script&lang=js&"
export * from "./BargainingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports